import { useState, useRef } from "react";

import { Table } from "antd";
import useSearchableColumns from "../../hooks/useSeachableColumns";

const PvTable = ({
  data,
  columns,
  onRowClick,
  maxActiveRow = 10,
  reverse = true,
  loading,
  style,
}) => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const searchableColumn = useSearchableColumns(
    columns,
    searchText,
    setSearchText,
    searchedColumn,
    setSearchedColumn,
    searchInput
  );

  return (
    <Table
      style={style}
      columns={searchableColumn}
      loading={loading}
      dataSource={reverse ? [...data].reverse() : data}
      size="small"
      pagination={{ pageSize: maxActiveRow }}
      onRow={(record) => ({
        onClick: () => onRowClick(record),
      })}
    />
  );
};

export default PvTable;
